module.exports = __webpack_public_path__ + "img/challenges-active.bd6dd323.png";